var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class Hotjar {
  constructor(logger, hotjarId) {
    __publicField(this, "logger");
    __publicField(this, "hotjarId");
    this.logger = logger;
    this.hotjarId = hotjarId;
  }
  async inject() {
    const hotjarShouldRecord = await this.isHotjarConfigRecording();
    if (hotjarShouldRecord) {
      this.logger.error("Hotjar is configured to record", { culprit: "Hotjar" });
    } else {
      const script = document.createElement("script");
      script.innerHTML = `
    (function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={hjid:${this.hotjarId},hjsv:6};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script');r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      a.appendChild(r);
  })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
`;
      document.head.append(script);
    }
  }
  /* 
      Hotjar configuration can be changed on the fly by anyone with access.
      Recording causes endless loop errors but we want to use feedback functions 
  
      This function checks if the Hotjar configuration is set to record
    */
  async isHotjarConfigRecording() {
    try {
      const request = await fetch(
        `https://static.hotjar.com/c/hotjar-${this.hotjarId}.js?sv=6`
      );
      const text = await request.text();
      const settingsJson = text.split(" || ")[1].split("!function()")[0].replace(";", "");
      const json = JSON.parse(`[${settingsJson}]`)[0];
      return json.record;
    } catch (error) {
      this.logger.error("Failed to read Hotjar config", {
        error,
        culprit: "Hotjar"
      });
      return false;
    }
  }
}
export {
  Hotjar
};
